import { Users } from 'lucide-react';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { cn } from '../../lib/utils';
import { TRAVELER_TYPES } from './tripConstants';

export const TravelerStep = ({ formData, updateFormData }) => (
  <div className="space-y-4">
    <div className="flex items-center gap-3 mb-3">
      <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-ocean to-sky flex items-center justify-center text-white shadow-lg">
        <Users className="w-5 h-5" />
      </div>
      <div>
        <h3 className="text-lg font-semibold text-ocean">Who's traveling?</h3>
        <p className="text-ocean/70 text-xs">Select your travel group type</p>
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      {TRAVELER_TYPES.map((type) => (
        <button
          key={type.value}
          onClick={() => {
            updateFormData('traveler_type', type.value);
            if (type.value === 'Couple' && formData.adults < 2) {
              updateFormData('adults', 2);
            }
            if (type.value === 'Solo') {
              updateFormData('adults', 1);
            }
          }}
          className={cn(
            'p-3.5 rounded-xl border-2 transition-all duration-300 text-center backdrop-blur-sm',
            formData.traveler_type === type.value
              ? 'border-gold bg-gradient-to-br from-gold/20 to-ocean/10 shadow-xl scale-105'
              : 'border-ocean/20 bg-white/50 hover:border-ocean/40 hover:shadow-lg hover:bg-white/70'
          )}
          data-testid={`traveler-type-${type.value}`}
        >
          <span className="text-2xl mb-1.5 block">{type.icon}</span>
          <span className="font-semibold text-ocean block text-sm">{type.label}</span>
          <span className="text-xs text-ocean/60">{type.desc}</span>
        </button>
      ))}
    </div>

    <div className="grid md:grid-cols-2 gap-4 mt-3">
      <div className="bg-gradient-to-br from-ocean/10 to-sky/10 p-4 rounded-xl border border-ocean/20 backdrop-blur-sm">
        <Label className="text-ocean font-medium text-sm">Number of Adults</Label>
        <div className="flex items-center gap-3 mt-2">
          <Button variant="outline" size="icon" className="rounded-full h-9 w-9 border-ocean text-ocean hover:bg-ocean hover:text-white"
            onClick={() => updateFormData('adults', Math.max(formData.traveler_type === 'Couple' ? 2 : 1, formData.adults - 1))} data-testid="adults-minus">
            -
          </Button>
          <span className="font-mono text-xl w-10 text-center font-bold text-ocean">{formData.adults}</span>
          <Button variant="outline" size="icon" className="rounded-full h-9 w-9 border-ocean text-ocean hover:bg-ocean hover:text-white"
            onClick={() => updateFormData('adults', formData.adults + 1)} data-testid="adults-plus">
            +
          </Button>
        </div>
      </div>
      <div className="bg-gradient-to-br from-gold/10 to-sky/10 p-4 rounded-xl border border-gold/20 backdrop-blur-sm">
        <Label className="text-ocean font-medium text-sm">Number of Kids</Label>
        <div className="flex items-center gap-3 mt-2">
          <Button variant="outline" size="icon" className="rounded-full h-9 w-9 border-gold text-gold hover:bg-gold hover:text-ocean"
            onClick={() => updateFormData('kids', Math.max(0, formData.kids - 1))} data-testid="kids-minus">
            -
          </Button>
          <span className="font-mono text-xl w-10 text-center font-bold text-gold">{formData.kids}</span>
          <Button variant="outline" size="icon" className="rounded-full h-9 w-9 border-gold text-gold hover:bg-gold hover:text-ocean"
            onClick={() => updateFormData('kids', formData.kids + 1)} data-testid="kids-plus">
            +
          </Button>
        </div>
      </div>
    </div>
  </div>
);
